{
  "all-devices": {
    "nav-item": {
      "label": "Devices"
    }
  },
  "deployments": {
    "nav-item": {
      "label": "Deployments"
    }
  },
  "deployment-rings": {
    "nav-item": {
      "label": "Rings"
    }
  },
  "documentation": {
    "nav-item": {
      "label": "Documentation"
    }
  },
  "home": {
    "nav-item": {
      "label": "Home"
    }
  },
  "page-not-found": {
    "message": "The page you are looking for does not exist",
    "title": "Page not found"
  },
  "software-management": {
    "nav-item": {
      "label": "Software management"
    }
  }
}
